import React, { useState } from 'react';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import Styles from './styles.module.css'
interface IconCopyProps {    
    copyToClipboard: Function
}


export const IconCopyClipboard: React.FC<IconCopyProps> = ({ copyToClipboard }) => {

    const [copied, setCopied] = useState(false)
    const copy = () => {
        copyToClipboard();
        setCopied(true)
        setTimeout(function () {
            setCopied(false)
        }, 1000);
    }

    return (
        <>        
            {copied ? <CheckOutlined className={Styles.CheckOutlined}/>
                : <CopyOutlined onClick={() => { copy() }} />
            }
        </>
    );
}